import React, { useEffect, useState } from "react";
import courses from "./courses.json";
import "./courses.css";
export default function Courses() {
  const frontendCourses = courses.filter((course) =>
    course.category.includes("frontend")
  );
  const backendCourses = courses.filter((course) =>
    course.category.includes("backend")
  );

  const [currentCourses, setCurrentCourses] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    setCurrentCourses(courses);
  }, []);
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    switch (category) {
      case "Backend":
        setCurrentCourses(backendCourses);
        break;
      case "Frontend":
        setCurrentCourses(frontendCourses);
        break;

      default:
        setCurrentCourses(courses);
        break;
    }
  };

  const handleMouseEnter = (e) => {
    e.target.className += " enter";
  };
  const handleMouseLeave = (e) => {
    e.target.className = "course-img-container";
  };

  return (
    <>
      <div className="coursesContainer">
        <div className="coursesTitle">
          <h1>Courses</h1>
          <div>
            <hr />
          </div>
        </div>
        <div className="courses-category">
          <span
            onClick={() => handleCategoryClick("All")}
            className={selectedCategory === "All" ? "categoryActive" : ""}
          >
            All
          </span>
          <span
            onClick={() => handleCategoryClick("Backend")}
            className={selectedCategory === "Backend" ? "categoryActive" : ""}
          >
            Backend
          </span>
          <span
            onClick={() => handleCategoryClick("Frontend")}
            className={selectedCategory === "Frontend" ? "categoryActive" : ""}
          >
            Frontend
          </span>
        </div>
        <div className="courses" key={selectedCategory}>
          {currentCourses.map((course) => {
            return (
              <div key={course.id} className="courseContainer">
                <div className="course-img-container">
                  <a href={course.certificate} target="_blank" rel="noreferrer">
                    <img
                      src={require(`${"" + course.img}`)}
                      alt={course.title}
                      onMouseEnter={(e) => handleMouseEnter(e)}
                      onMouseLeave={(e) => handleMouseLeave(e)}
                    />
                  </a>
                </div>
                <div className="course-content">
                  <p className="course-header">
                    {course.date} - {course.platform}
                  </p>

                  <div className="course-content-container">
                    <div className="course-details">
                      <span className="course-title">{course.title}</span>
                      <span className="course-author">By {course.author}</span>
                    </div>
                    <div className="course-certificate">
                      <a
                        href={course.certificate}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Certificate
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
